import { format } from 'date-fns'

export class DateSelectVm {
  constructor(
    private selectedDate: Date | undefined,
    private placeholder: string
  ) {}

  get formattedDate() {
    return this.selectedDate && format(this.selectedDate, 'dd MMM yyyy')
  }

  get hasValue() {
    return this.formattedDate !== undefined
  }

  get triggerContent() {
    return this.hasValue ? this.formattedDate : this.placeholder
  }
}
